import React, { useEffect } from 'react';
import './Snackbar.css';

const Snackbar = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`snackbar snackbar-${type}`}>
      <span className="snackbar-icon">
        {type === 'success' && '✓'}
        {type === 'error' && '✕'}
        {type === 'warning' && '⚠'}
        {type === 'info' && 'ℹ'}
      </span>
      <span className="snackbar-message">{message}</span>
      <button className="snackbar-close" onClick={onClose}>×</button>
    </div>
  );
};

export default Snackbar;
